// Extracted from docs/R&S-Takeoffsheet.xlsx, sheet 'MANHOLE RATES' (column A=CODE,
// formatted 'diameterMm,depth.toFixed(2)' e.g. "1050,1.00"; O=Disposal (m3),
// AB=Granular Backfill (m3)). Fixed per-manhole volumes (not £ rates) used by the
// Foul/Storm Summary sheet's Surplus/Backfill columns — see foulSummaryUtils.ts
// buildFoulSurplusBackfillData. Do not hand-edit; regenerate from the source
// workbook if the rates change.

export interface ManholeRateVolumeEntry {
  code: string; // '<diameterMm>,<depthCategory.toFixed(2)>' e.g. "1050,1.00"
  disposalM3: number; // m3 — disposal / arisings volume for this manhole excavation
  backfillM3: number; // m3 — granular backfill volume for this manhole excavation
}

export const MANHOLE_RATES_VOLUME: ManholeRateVolumeEntry[] = [
  { code: '1050,1.00', disposalM3: 3.562, backfillM3: 2.129 },
  { code: '1050,1.25', disposalM3: 4.675, backfillM3: 2.794 },
  { code: '1050,1.50', disposalM3: 5.788, backfillM3: 3.459 },
  { code: '1050,1.75', disposalM3: 6.901, backfillM3: 4.125 },
  { code: '1050,2.00', disposalM3: 8.014, backfillM3: 4.79 },
  { code: '1050,2.25', disposalM3: 9.127, backfillM3: 5.455 },
  { code: '1050,2.50', disposalM3: 10.24, backfillM3: 6.12 },
  { code: '1050,2.75', disposalM3: 11.353, backfillM3: 6.786 },
  { code: '1050,3.00', disposalM3: 12.466, backfillM3: 7.451 },
  { code: '1050,3.25', disposalM3: 13.579, backfillM3: 8.116 },
  { code: '1050,3.50', disposalM3: 14.692, backfillM3: 8.781 },
  { code: '1050,3.75', disposalM3: 15.805, backfillM3: 9.446 },
  { code: '1050,4.00', disposalM3: 16.918, backfillM3: 10.112 },
  { code: '1050,4.25', disposalM3: 18.031, backfillM3: 10.777 },
  { code: '1050,4.50', disposalM3: 19.144, backfillM3: 11.442 },
  { code: '1050,4.75', disposalM3: 20.257, backfillM3: 12.107 },
  { code: '1050,5.00', disposalM3: 21.37, backfillM3: 12.773 },
  { code: '1050,5.25', disposalM3: 22.483, backfillM3: 13.438 },
  { code: '1050,5.50', disposalM3: 23.596, backfillM3: 14.103 },
  { code: '1050,5.75', disposalM3: 24.709, backfillM3: 14.768 },
  { code: '1050,6.00', disposalM3: 25.822, backfillM3: 15.434 },
  { code: '1200,1.00', disposalM3: 4.158, backfillM3: 2.385 },
  { code: '1200,1.25', disposalM3: 5.458, backfillM3: 3.13 },
  { code: '1200,1.50', disposalM3: 6.757, backfillM3: 3.875 },
  { code: '1200,1.75', disposalM3: 8.057, backfillM3: 4.621 },
  { code: '1200,2.00', disposalM3: 9.356, backfillM3: 5.366 },
  { code: '1200,2.25', disposalM3: 10.656, backfillM3: 6.111 },
  { code: '1200,2.50', disposalM3: 11.955, backfillM3: 6.856 },
  { code: '1200,2.75', disposalM3: 13.255, backfillM3: 7.602 },
  { code: '1200,3.00', disposalM3: 14.554, backfillM3: 8.347 },
  { code: '1200,3.25', disposalM3: 15.854, backfillM3: 9.092 },
  { code: '1200,3.50', disposalM3: 17.153, backfillM3: 9.837 },
  { code: '1200,3.75', disposalM3: 18.453, backfillM3: 10.583 },
  { code: '1200,4.00', disposalM3: 19.752, backfillM3: 11.328 },
  { code: '1200,4.25', disposalM3: 21.052, backfillM3: 12.073 },
  { code: '1200,4.50', disposalM3: 22.351, backfillM3: 12.818 },
  { code: '1200,4.75', disposalM3: 23.651, backfillM3: 13.564 },
  { code: '1200,5.00', disposalM3: 24.95, backfillM3: 14.309 },
  { code: '1200,5.25', disposalM3: 26.25, backfillM3: 15.054 },
  { code: '1200,5.50', disposalM3: 27.549, backfillM3: 15.799 },
  { code: '1200,5.75', disposalM3: 28.849, backfillM3: 16.545 },
  { code: '1200,6.00', disposalM3: 30.148, backfillM3: 17.29 },
  { code: '1350,1.00', disposalM3: 4.763, backfillM3: 2.636 },
  { code: '1350,1.25', disposalM3: 6.252, backfillM3: 3.459 },
  { code: '1350,1.50', disposalM3: 7.74, backfillM3: 4.283 },
  { code: '1350,1.75', disposalM3: 9.229, backfillM3: 5.107 },
  { code: '1350,2.00', disposalM3: 10.717, backfillM3: 5.93 },
  { code: '1350,2.25', disposalM3: 12.206, backfillM3: 6.754 },
  { code: '1350,2.50', disposalM3: 13.694, backfillM3: 7.578 },
  { code: '1350,2.75', disposalM3: 15.183, backfillM3: 8.401 },
  { code: '1350,3.00', disposalM3: 16.671, backfillM3: 9.225 },
  { code: '1350,3.25', disposalM3: 18.16, backfillM3: 10.049 },
  { code: '1350,3.50', disposalM3: 19.648, backfillM3: 10.872 },
  { code: '1350,3.75', disposalM3: 21.137, backfillM3: 11.696 },
  { code: '1350,4.00', disposalM3: 22.625, backfillM3: 12.52 },
  { code: '1350,4.25', disposalM3: 24.114, backfillM3: 13.343 },
  { code: '1350,4.50', disposalM3: 25.602, backfillM3: 14.167 },
  { code: '1350,4.75', disposalM3: 27.091, backfillM3: 14.99 },
  { code: '1350,5.00', disposalM3: 28.579, backfillM3: 15.814 },
  { code: '1350,5.25', disposalM3: 30.068, backfillM3: 16.638 },
  { code: '1350,5.50', disposalM3: 31.556, backfillM3: 17.461 },
  { code: '1350,5.75', disposalM3: 33.045, backfillM3: 18.285 },
  { code: '1350,6.00', disposalM3: 34.533, backfillM3: 19.109 },
  { code: '1500,1.00', disposalM3: 5.408, backfillM3: 2.894 },
  { code: '1500,1.25', disposalM3: 7.098, backfillM3: 3.799 },
  { code: '1500,1.50', disposalM3: 8.788, backfillM3: 4.703 },
  { code: '1500,1.75', disposalM3: 10.478, backfillM3: 5.608 },
  { code: '1500,2.00', disposalM3: 12.168, backfillM3: 6.512 },
  { code: '1500,2.25', disposalM3: 13.858, backfillM3: 7.417 },
  { code: '1500,2.50', disposalM3: 15.548, backfillM3: 8.321 },
  { code: '1500,2.75', disposalM3: 17.238, backfillM3: 9.226 },
  { code: '1500,3.00', disposalM3: 18.928, backfillM3: 10.13 },
  { code: '1500,3.25', disposalM3: 20.618, backfillM3: 11.035 },
  { code: '1500,3.50', disposalM3: 22.308, backfillM3: 11.939 },
  { code: '1500,3.75', disposalM3: 23.998, backfillM3: 12.844 },
  { code: '1500,4.00', disposalM3: 25.688, backfillM3: 13.748 },
  { code: '1500,4.25', disposalM3: 27.378, backfillM3: 14.653 },
  { code: '1500,4.50', disposalM3: 29.068, backfillM3: 15.557 },
  { code: '1500,4.75', disposalM3: 30.758, backfillM3: 16.462 },
  { code: '1500,5.00', disposalM3: 32.448, backfillM3: 17.366 },
  { code: '1500,5.25', disposalM3: 34.138, backfillM3: 18.271 },
  { code: '1500,5.50', disposalM3: 35.828, backfillM3: 19.175 },
  { code: '1500,5.75', disposalM3: 37.518, backfillM3: 20.08 },
  { code: '1500,6.00', disposalM3: 39.208, backfillM3: 20.984 },
  { code: '1500,1.00', disposalM3: 5.408, backfillM3: 2.894 },
  { code: '1500,1.25', disposalM3: 7.098, backfillM3: 3.799 },
  { code: '1500,1.50', disposalM3: 8.788, backfillM3: 4.703 },
  { code: '1500,1.75', disposalM3: 10.478, backfillM3: 5.608 },
  { code: '1500,2.00', disposalM3: 12.168, backfillM3: 6.512 },
  { code: '1500,2.25', disposalM3: 13.858, backfillM3: 7.417 },
  { code: '1500,2.50', disposalM3: 15.548, backfillM3: 8.321 },
  { code: '1500,2.75', disposalM3: 17.238, backfillM3: 9.226 },
  { code: '1500,3.00', disposalM3: 18.928, backfillM3: 10.13 },
  { code: '1500,3.25', disposalM3: 20.618, backfillM3: 11.035 },
  { code: '1500,3.50', disposalM3: 22.308, backfillM3: 11.939 },
  { code: '1500,3.75', disposalM3: 23.998, backfillM3: 12.844 },
  { code: '1500,4.00', disposalM3: 25.688, backfillM3: 13.748 },
  { code: '1500,4.25', disposalM3: 27.378, backfillM3: 14.653 },
  { code: '1500,4.50', disposalM3: 29.068, backfillM3: 15.557 },
  { code: '1500,4.75', disposalM3: 30.758, backfillM3: 16.462 },
  { code: '1500,5.00', disposalM3: 32.448, backfillM3: 17.366 },
  { code: '1500,5.25', disposalM3: 34.138, backfillM3: 18.271 },
  { code: '1500,5.50', disposalM3: 35.828, backfillM3: 19.175 },
  { code: '1500,5.75', disposalM3: 37.518, backfillM3: 20.08 },
  { code: '1500,6.00', disposalM3: 39.208, backfillM3: 20.984 },
  { code: '1800,1.00', disposalM3: 6.868, backfillM3: 3.456 },
  { code: '1800,1.25', disposalM3: 9.014, backfillM3: 4.537 },
  { code: '1800,1.50', disposalM3: 11.161, backfillM3: 5.617 },
  { code: '1800,1.75', disposalM3: 13.307, backfillM3: 6.697 },
  { code: '1800,2.00', disposalM3: 15.453, backfillM3: 7.777 },
  { code: '1800,2.25', disposalM3: 17.599, backfillM3: 8.857 },
  { code: '1800,2.50', disposalM3: 19.746, backfillM3: 9.937 },
  { code: '1800,2.75', disposalM3: 21.892, backfillM3: 11.018 },
  { code: '1800,3.00', disposalM3: 24.038, backfillM3: 12.098 },
  { code: '1800,3.25', disposalM3: 26.184, backfillM3: 13.178 },
  { code: '1800,3.50', disposalM3: 28.331, backfillM3: 14.258 },
  { code: '1800,3.75', disposalM3: 30.477, backfillM3: 15.338 },
  { code: '1800,4.00', disposalM3: 32.623, backfillM3: 16.418 },
  { code: '1800,4.25', disposalM3: 34.769, backfillM3: 17.498 },
  { code: '1800,4.50', disposalM3: 36.916, backfillM3: 18.579 },
  { code: '1800,4.75', disposalM3: 39.062, backfillM3: 19.659 },
  { code: '1800,5.00', disposalM3: 41.208, backfillM3: 20.739 },
  { code: '1800,5.25', disposalM3: 43.354, backfillM3: 21.819 },
  { code: '1800,5.50', disposalM3: 45.501, backfillM3: 22.899 },
  { code: '1800,5.75', disposalM3: 47.647, backfillM3: 23.979 },
  { code: '1800,6.00', disposalM3: 49.793, backfillM3: 25.059 },
  { code: '1800,1.00', disposalM3: 6.868, backfillM3: 3.456 },
  { code: '1800,1.25', disposalM3: 9.014, backfillM3: 4.537 },
  { code: '1800,1.50', disposalM3: 11.161, backfillM3: 5.617 },
  { code: '1800,1.75', disposalM3: 13.307, backfillM3: 6.697 },
  { code: '1800,2.00', disposalM3: 15.453, backfillM3: 7.777 },
  { code: '1800,2.25', disposalM3: 17.599, backfillM3: 8.857 },
  { code: '1800,2.50', disposalM3: 19.746, backfillM3: 9.937 },
  { code: '1800,2.75', disposalM3: 21.892, backfillM3: 11.018 },
  { code: '1800,3.00', disposalM3: 24.038, backfillM3: 12.098 },
  { code: '1800,3.25', disposalM3: 26.184, backfillM3: 13.178 },
  { code: '1800,3.50', disposalM3: 28.331, backfillM3: 14.258 },
  { code: '1800,3.75', disposalM3: 30.477, backfillM3: 15.338 },
  { code: '1800,4.00', disposalM3: 32.623, backfillM3: 16.418 },
  { code: '1800,4.25', disposalM3: 34.769, backfillM3: 17.498 },
  { code: '1800,4.50', disposalM3: 36.916, backfillM3: 18.579 },
  { code: '1800,4.75', disposalM3: 39.062, backfillM3: 19.659 },
  { code: '1800,5.00', disposalM3: 41.208, backfillM3: 20.739 },
  { code: '1800,5.25', disposalM3: 43.354, backfillM3: 21.819 },
  { code: '1800,5.50', disposalM3: 45.501, backfillM3: 22.899 },
  { code: '1800,5.75', disposalM3: 47.647, backfillM3: 23.979 },
  { code: '1800,6.00', disposalM3: 49.793, backfillM3: 25.059 },
  { code: '2100,1.00', disposalM3: 8.45, backfillM3: 4.037 },
  { code: '2100,1.25', disposalM3: 11.091, backfillM3: 5.299 },
  { code: '2100,1.50', disposalM3: 13.732, backfillM3: 6.561 },
  { code: '2100,1.75', disposalM3: 16.373, backfillM3: 7.823 },
  { code: '2100,2.00', disposalM3: 19.013, backfillM3: 9.084 },
  { code: '2100,2.25', disposalM3: 21.654, backfillM3: 10.346 },
  { code: '2100,2.50', disposalM3: 24.295, backfillM3: 11.608 },
  { code: '2100,2.75', disposalM3: 26.936, backfillM3: 12.869 },
  { code: '2100,3.00', disposalM3: 29.576, backfillM3: 14.131 },
  { code: '2100,3.25', disposalM3: 32.217, backfillM3: 15.393 },
  { code: '2100,3.50', disposalM3: 34.858, backfillM3: 16.655 },
  { code: '2100,3.75', disposalM3: 37.499, backfillM3: 17.916 },
  { code: '2100,4.00', disposalM3: 40.139, backfillM3: 19.178 },
  { code: '2100,4.25', disposalM3: 42.78, backfillM3: 20.44 },
  { code: '2100,4.50', disposalM3: 45.421, backfillM3: 21.701 },
  { code: '2100,4.75', disposalM3: 48.062, backfillM3: 22.963 },
  { code: '2100,5.00', disposalM3: 50.702, backfillM3: 24.225 },
  { code: '2100,5.25', disposalM3: 53.343, backfillM3: 25.486 },
  { code: '2100,5.50', disposalM3: 55.984, backfillM3: 26.748 },
  { code: '2100,5.75', disposalM3: 58.625, backfillM3: 28.01 },
  { code: '2100,6.00', disposalM3: 61.265, backfillM3: 29.272 },
  { code: '2400,1.00', disposalM3: 10.253, backfillM3: 4.672 },
  { code: '2400,1.25', disposalM3: 13.457, backfillM3: 6.132 },
  { code: '2400,1.50', disposalM3: 16.661, backfillM3: 7.593 },
  { code: '2400,1.75', disposalM3: 19.865, backfillM3: 9.053 },
  { code: '2400,2.00', disposalM3: 23.069, backfillM3: 10.513 },
  { code: '2400,2.25', disposalM3: 26.273, backfillM3: 11.973 },
  { code: '2400,2.50', disposalM3: 29.477, backfillM3: 13.433 },
  { code: '2400,2.75', disposalM3: 32.681, backfillM3: 14.893 },
  { code: '2400,3.00', disposalM3: 35.885, backfillM3: 16.353 },
  { code: '2400,3.25', disposalM3: 39.089, backfillM3: 17.813 },
  { code: '2400,3.50', disposalM3: 42.293, backfillM3: 19.273 },
  { code: '2400,3.75', disposalM3: 45.497, backfillM3: 20.734 },
  { code: '2400,4.00', disposalM3: 48.701, backfillM3: 22.194 },
  { code: '2400,4.25', disposalM3: 51.905, backfillM3: 23.654 },
  { code: '2400,4.50', disposalM3: 55.109, backfillM3: 25.114 },
  { code: '2400,4.75', disposalM3: 58.313, backfillM3: 26.574 },
  { code: '2400,5.00', disposalM3: 61.517, backfillM3: 28.034 },
  { code: '2400,5.25', disposalM3: 64.721, backfillM3: 29.494 },
  { code: '2400,5.50', disposalM3: 67.925, backfillM3: 30.954 },
  { code: '2400,5.75', disposalM3: 71.129, backfillM3: 32.414 },
  { code: '2400,6.00', disposalM3: 74.333, backfillM3: 33.875 },
  { code: '2700,1.00', disposalM3: 12.168, backfillM3: 5.325 },
  { code: '2700,1.25', disposalM3: 15.971, backfillM3: 6.989 },
  { code: '2700,1.50', disposalM3: 19.773, backfillM3: 8.653 },
  { code: '2700,1.75', disposalM3: 23.576, backfillM3: 10.317 },
  { code: '2700,2.00', disposalM3: 27.378, backfillM3: 11.981 },
  { code: '2700,2.25', disposalM3: 31.181, backfillM3: 13.645 },
  { code: '2700,2.50', disposalM3: 34.983, backfillM3: 15.309 },
  { code: '2700,2.75', disposalM3: 38.786, backfillM3: 16.973 },
  { code: '2700,3.00', disposalM3: 42.588, backfillM3: 18.637 },
  { code: '2700,3.25', disposalM3: 46.391, backfillM3: 20.301 },
  { code: '2700,3.50', disposalM3: 50.193, backfillM3: 21.964 },
  { code: '2700,3.75', disposalM3: 53.996, backfillM3: 23.628 },
  { code: '2700,4.00', disposalM3: 57.798, backfillM3: 25.292 },
  { code: '2700,4.25', disposalM3: 61.601, backfillM3: 26.956 },
  { code: '2700,4.50', disposalM3: 65.403, backfillM3: 28.62 },
  { code: '2700,4.75', disposalM3: 69.206, backfillM3: 30.284 },
  { code: '2700,5.00', disposalM3: 73.008, backfillM3: 31.948 },
  { code: '2700,5.25', disposalM3: 76.811, backfillM3: 33.612 },
  { code: '2700,5.50', disposalM3: 80.613, backfillM3: 35.276 },
  { code: '2700,5.75', disposalM3: 84.416, backfillM3: 36.94 },
  { code: '2700,6.00', disposalM3: 88.218, backfillM3: 38.604 },
  { code: '3000,1.00', disposalM3: 14.93, backfillM3: 6.234 },
  { code: '3000,1.25', disposalM3: 19.595, backfillM3: 8.182 },
  { code: '3000,1.50', disposalM3: 24.261, backfillM3: 10.13 },
  { code: '3000,1.75', disposalM3: 28.926, backfillM3: 12.078 },
  { code: '3000,2.00', disposalM3: 33.592, backfillM3: 14.025 },
  { code: '3000,2.25', disposalM3: 38.257, backfillM3: 15.973 },
  { code: '3000,2.50', disposalM3: 42.923, backfillM3: 17.921 },
  { code: '3000,2.75', disposalM3: 47.588, backfillM3: 19.869 },
  { code: '3000,3.00', disposalM3: 52.254, backfillM3: 21.817 },
  { code: '3000,3.25', disposalM3: 56.919, backfillM3: 23.765 },
  { code: '3000,3.50', disposalM3: 61.585, backfillM3: 25.713 },
  { code: '3000,3.75', disposalM3: 66.25, backfillM3: 27.661 },
  { code: '3000,4.00', disposalM3: 70.916, backfillM3: 29.609 },
  { code: '3000,4.25', disposalM3: 75.581, backfillM3: 31.557 },
  { code: '3000,4.50', disposalM3: 80.247, backfillM3: 33.505 },
  { code: '3000,4.75', disposalM3: 84.912, backfillM3: 35.453 },
  { code: '3000,5.00', disposalM3: 89.578, backfillM3: 37.401 },
  { code: '3000,5.25', disposalM3: 94.243, backfillM3: 39.349 },
  { code: '3000,5.50', disposalM3: 98.909, backfillM3: 41.297 },
  { code: '3000,5.75', disposalM3: 103.574, backfillM3: 43.245 },
  { code: '3000,6.00', disposalM3: 108.24, backfillM3: 45.193 },
  { code: '3600,1.00', disposalM3: 18.974, backfillM3: 7.516 },
  { code: '3600,1.25', disposalM3: 24.903, backfillM3: 9.865 },
  { code: '3600,1.50', disposalM3: 30.832, backfillM3: 12.214 },
  { code: '3600,1.75', disposalM3: 36.761, backfillM3: 14.562 },
  { code: '3600,2.00', disposalM3: 42.691, backfillM3: 16.911 },
  { code: '3600,2.25', disposalM3: 48.62, backfillM3: 19.26 },
  { code: '3600,2.50', disposalM3: 54.549, backfillM3: 21.609 },
  { code: '3600,2.75', disposalM3: 60.478, backfillM3: 23.957 },
  { code: '3600,3.00', disposalM3: 66.408, backfillM3: 26.306 },
  { code: '3600,3.25', disposalM3: 72.337, backfillM3: 28.655 },
  { code: '3600,3.50', disposalM3: 78.266, backfillM3: 31.004 },
  { code: '3600,3.75', disposalM3: 84.195, backfillM3: 33.352 },
  { code: '3600,4.00', disposalM3: 90.125, backfillM3: 35.701 },
  { code: '3600,4.25', disposalM3: 96.054, backfillM3: 38.05 },
  { code: '3600,4.50', disposalM3: 101.983, backfillM3: 40.399 },
  { code: '3600,4.75', disposalM3: 107.912, backfillM3: 42.748 },
  { code: '3600,5.00', disposalM3: 113.842, backfillM3: 45.096 },
  { code: '3600,5.25', disposalM3: 119.771, backfillM3: 47.445 },
  { code: '3600,5.50', disposalM3: 125.7, backfillM3: 49.794 },
  { code: '3600,5.75', disposalM3: 131.629, backfillM3: 52.143 },
  { code: '3600,6.00', disposalM3: 137.559, backfillM3: 54.491 },
  { code: '4000,1.00', disposalM3: 22.472, backfillM3: 8.591 },
  { code: '4000,1.25', disposalM3: 29.495, backfillM3: 11.275 },
  { code: '4000,1.50', disposalM3: 36.517, backfillM3: 13.96 },
  { code: '4000,1.75', disposalM3: 43.54, backfillM3: 16.644 },
  { code: '4000,2.00', disposalM3: 50.562, backfillM3: 19.329 },
  { code: '4000,2.25', disposalM3: 57.585, backfillM3: 22.014 },
  { code: '4000,2.50', disposalM3: 64.607, backfillM3: 24.698 },
  { code: '4000,2.75', disposalM3: 71.63, backfillM3: 27.383 },
  { code: '4000,3.00', disposalM3: 78.652, backfillM3: 30.067 },
  { code: '4000,3.25', disposalM3: 85.675, backfillM3: 32.752 },
  { code: '4000,3.50', disposalM3: 92.697, backfillM3: 35.436 },
  { code: '4000,3.75', disposalM3: 99.72, backfillM3: 38.121 },
  { code: '4000,4.00', disposalM3: 106.742, backfillM3: 40.806 },
  { code: '4000,4.25', disposalM3: 113.765, backfillM3: 43.49 },
  { code: '4000,4.50', disposalM3: 120.787, backfillM3: 46.175 },
  { code: '4000,4.75', disposalM3: 127.81, backfillM3: 48.859 },
  { code: '4000,5.00', disposalM3: 134.832, backfillM3: 51.544 },
  { code: '4000,5.25', disposalM3: 141.855, backfillM3: 54.228 },
  { code: '4000,5.50', disposalM3: 148.877, backfillM3: 56.913 },
  { code: '4000,5.75', disposalM3: 155.9, backfillM3: 59.598 },
  { code: '4000,6.00', disposalM3: 162.922, backfillM3: 62.282 },
];

const manholeRateIndex = new Map<string, ManholeRateVolumeEntry>(
  MANHOLE_RATES_VOLUME.map((e) => [e.code, e]),
);

/**
 * Exact-match lookup by 'diameterMm,depthCategory' code, mirroring the source
 * IFNA(XLOOKUP(...),0) — no match (or missing diameter/depth) returns 0 for both fields.
 */
export const findManholeRateVolume = (
  diameterMm: number | undefined,
  depthCategory: number | undefined,
): { disposalM3: number; backfillM3: number } => {
  if (diameterMm === undefined || depthCategory === undefined) return { disposalM3: 0, backfillM3: 0 };
  const entry = manholeRateIndex.get(`${diameterMm},${depthCategory.toFixed(2)}`);
  return entry
    ? { disposalM3: entry.disposalM3, backfillM3: entry.backfillM3 }
    : { disposalM3: 0, backfillM3: 0 };
};
